import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";


export const deleteAccount = createAsyncThunk(
    "accounts/deleteAccount",
    async ({ token }, { rejectWithValue }) => {
      try {
          
        const response = await axios.delete(
          `${process.env.REACT_APP_BASE_URL}/accounts`,
          
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        if (response.data.status) {
            console.log(response.data)
          // toast(response.data.response)
          return response.data.response;
        } else {
          return rejectWithValue(response.data.message || "Delete failed");
        }
      } catch (error) {
        // console.log(error)
        return rejectWithValue(error.response?.data?.message || "Error Deleting account");
      }
    }
  );

// Async thunk for updating an account
export const updateAccount = createAsyncThunk(
  "accounts/updateAccount",
  async ({ token, data }, { rejectWithValue }) => {
    try {
        console.log(data)
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/accounts`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        toast.success(response.data.response)
        return response.data.response;
      } else {
        return rejectWithValue(response.data.message || "Update failed");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating account")
      return rejectWithValue(error.response?.data?.message || "Error updating account");
    }
  }
);

// Async thunk for fetching account details
export const getAccount = createAsyncThunk(
  "accounts/getAccount",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/accounts`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue(response.data.message || "Failed to fetch account");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error fetching account");
    }
  }
);

// Redux slice
const accountSlice = createSlice({
  name: "account",
  initialState: {
    accountsDetails: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    reset:(state)=>{
        state.accountsDetails=null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAccount.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAccount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.accountsDetails = action.payload;
      })
      .addCase(getAccount.rejected, (state, action) => {
        state.isLoading = false;
        // toast(action.payload)
        state.error = action.payload;
      })
      .addCase(updateAccount.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateAccount.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.accountsDetails = action.payload;
      })
      .addCase(updateAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteAccount.fulfilled ,(state,action)=>{
        toast.success(action.payload)
      })
      .addCase(deleteAccount.rejected, (state,action)=>{
        toast.error(action.payload)
      })
  },
});


export const { reset } = accountSlice.actions;
export default accountSlice.reducer;
